import { render, staticRenderFns } from "./coupon_setting.vue?vue&type=template&id=58f755c8&scoped=true"
import script from "./coupon_setting.vue?vue&type=script&lang=js"
export * from "./coupon_setting.vue?vue&type=script&lang=js"
import style0 from "./coupon_setting.vue?vue&type=style&index=0&id=58f755c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f755c8",
  null
  
)

export default component.exports